import React from "react";
import { Box } from "@material-ui/core";
import ConsentForm from "./ConsentForm";
import { ErrorHandler } from "../../helpers";
import { ErrorPage } from "../ErrorPage";
import { RouteComponentProps } from "@reach/router";

export interface MyConsentsProps extends RouteComponentProps {}
const Consents = (props: MyConsentsProps) => {
	return (
		<ErrorHandler
			// @ts-ignore
			fallback={(error: any) => (
				<Box p={3} display="flex" alignItems="center" justifyContent="center">
					<ErrorPage error={error} />
				</Box>
			)}
		>
			<ConsentForm {...props} />
		</ErrorHandler>
	);
};

export { Consents };
